/**
  Localstrageへローカル設定情報を読み書きする
*/
import Vue from 'vue'
// import VueOnsen from 'vue-onsenui'
//import VeeValidate from 'vee-validate'
import setting from '../../ms.config'
import labelJa from '../../localize/ja.json'
import labelEn from '../../localize/en.json'
import labelCh from '../../localize/ch.json'
import moment from 'moment'
//import validationJa from 'vee-validate/dist/locale/ja'
//import validationEn from 'vee-validate/dist/locale/en'
//import validationKo from 'vee-validate/dist/locale/ko'

const LOCAL_STORAGE_KEY_LANGUAGE = 'language'
const LOCAL_STORAGE_KEY_USERID = 'user_id'
const LOCAL_STORAGE_KEY_PASSWORD = 'password'
const LOCAL_STORAGE_KEY_TOKEN = 'token'
const LOCAL_STORAGE_KEY_CART_DATA = 'cart'
const LOCAL_STORAGE_KEY_SHOW_INFO = 'show_info'

const LOCAL_STORAGE_KEY_LINE_TOKEN = 'line_token'
const LOCAL_STORAGE_KEY_REPEATER_TOKEN = 'repeater_token'
const LOCAL_STORAGE_KEY_ALC_TOKEN = 'alc_token'
const LOCAL_STORAGE_KEY_UID = 'uid'

const state = {
  lang: '',
  rememberUserId: '',
  rememberPassowrd: '',
  token: '',
  //deviceId: 'F34BB1EC-794E-4447-855F-9DD406F32250',
  deviceId: setting.DEVICE_ID,
  platform: 'undifined',
  deviceVersion: '0.0.0',
  strage_saved_cart: '',
  session_key: '',
  show_scroll_info: 0,
  line_token:'',
  alc_token:'',
  repeater_token:'',
  uid: '',
}

const getters = {
  localizeLabel: state => (pageName, keyName) => {
    let language
    try {
      switch (state.lang) {
        case '1': //ja
          language = labelJa
          break
        case '5': //en
          language = labelEn
          break
        case '22': //ch
          language = labelCh
          break
        default:
          language = labelJa
          break
      }
      return language.pages[pageName].labels[keyName]
    } catch (e) {
      // console.log('in localizeLabel: matched key not exist')
    }
  },
  currentLang: state => state.lang,
  currentLangName: state => {
    switch (state.lang) {
      case '1':
        return '日本語'
        break
      case '5':
        return 'English'
        break
      case '22':
        return '中 文'
        break
      default:
        return '日本語'
        break
    }
  },
  currentLangCode: state => {
    switch (state.lang) {
      case '1':
        return 'ja'
        break
      case '5':
        return 'en'
        break
      case '22':
        return 'ch'
        break
      default:
        return 'ja'
        break
    }
  },
  ShowScrollInfo: state => state.show_scroll_info,
  rememberUserId: state => state.rememberUserId,
  rememberPassword: state => state.rememberPassowrd,
  deviceId: state => state.deviceId,
  platform: state => state.platform,
  deviceVersion: state => state.deviceVersion,
  token: state => state.token,
  repeater_token: state => state.repeater_token,
  line_token: state => state.line_token,
  alc_token: state => state.alc_token,
  StrageSavedCart: state => state.strage_saved_cart,
  SessionKey: state => state.session_key,
  UID: state => state.uid,
  ConvertAppError: (state,getters) => (response) =>{
    try{

      if('Status' in response){
        debugger
        if(response.Status=='13'){
          return ''+response.Message+'は品切れのため、ご注文が受け付けられませんでした。<br>もう一度注文をご確認ください。' //欠品と数量オーバーの場合は、商品名が入るのでPOSのメッセージをそのまま返す
        }else if(response.Status=='14'){
          return ''+response.Message+'は品切れのため、ご注文が受け付けられませんでした。<br>もう一度注文をご確認ください。'
        }else{
          return getters.localizeLabel('POS_STATUS',response.Status)
        }
        
        /*
        switch (response.Status){
          case '1':
            return '該当する伝票が存在しません'
            break
          case '2':
            return '現在会計処理中です'
            break
          case '3':
            return 'この伝票は既に会計処理済みです'
            break  
          case '11':
            return 'ご注文が受け付けられませんでした。<br>制限時間を超過しています。'
            break  
          case '12':
            return 'ご注文が受け付けられませんでした。<br>存在しない商品が注文されました。もういちど注文をご確認ください。'
            break  
          case '13':
            return 'ご注文が受け付けられませんでした。<br>すでに欠品した商品があります。もういちど注文をご確認ください。'
            break  
          case '14':
            return 'ご注文が受け付けられませんでした。<br>限定注文数をオーバーした商品があります。もういちど注文をご確認ください。'
            break  
          case '98':
            return 'ご注文が受け付けられませんでした。<br>現在、全席オーダーストップとなっております。'
            break  
          case '99':
            return '閉店中につきご注文は受け付けられません。'
            break  
          case '100':
            return 'ご注文が受け付けられませんでした。<br>注文の明細が0件です。'
            break  
          case '101':
            return 'ご注文が受け付けられませんでした。<br>注文の登録時にエラーが発生しました。お近くのスタッフにご確認ください。'
            break  
          case '102':
            return '呼び出しできませんでした。お手数ですが、お近くのスタッフにご確認ください。'
            break  
          case '901':
            return 'グローバル店舗コードの不一致です'
            break                
          case '999':
            return 'システムエラーが発生しました。'
            break                
        }
        */
      }else{
        return response //APP以外のエラー（ネット不通など）
      }
    }catch(e){
      return response //APP以外のエラー（ネット不通など）
    }
    
  },
}

// actions
const actions = {
  getSettings({ commit ,getters, dispatch }) {
    //session_keyの設定（現在のSHOPDATE_SHOPCODE_SLIPNO）
    commit('setSessionKey', getters.SlipDate+"_"+getters.ShopCode+"_"+getters.SlipNo )

    // 言語設定の読み込み
    commit('getSettings')
    dispatch('SetCartSavedData', getters.StrageSavedCart)
  },
  clearDeviceInfo() {
    localStorage.removeItem(LOCAL_STORAGE_KEY_USERID)
    localStorage.removeItem(LOCAL_STORAGE_KEY_PASSWORD)
    localStorage.removeItem(LOCAL_STORAGE_KEY_TOKEN)
  },
  /* 言語設定をlocalstrageへ保存 */
  setLanguage({ commit, getters }, lang) {
    switch (lang) {
      case 'ja':
        commit('setLanguageLabels', '1')
        break
      case 'en':
        commit('setLanguageLabels', '5')
        break
      case 'ch':
        commit('setLanguageLabels', '22')
        break
      default:
        commit('setLanguageLabels', '1')
        break
    }

    localStorage.setItem(LOCAL_STORAGE_KEY_LANGUAGE, getters.currentLang)
    // VeeValidationエラーメッセージの言語選択
    /*
    if (lang === '5') {
      VeeValidate.Validator.localize('en', validationEn)
    } else if (lang === '22') {
      VeeValidate.Validator.localize('ch', validationKo)
    } else {
      VeeValidate.Validator.localize('ja', validationJa)
    }
    */
    
  },

  /* セッショントークンを保存 */
  setSessionToken({ commit }) {
    commit('setSessionToken')
  },

  /* LINEページ表示トークンを保存 */
  setLineToken({ commit }) {
    commit('updateLineToken','line_page_shown')
  },
  /* リピーターページ表示トークンを保存 */
  setRepeaterToken({ commit }) {
    commit('updateRepeaterToken','repeater_page_shown')
  },
  /* アルコールページ表示トークンを保存 */
  setAlcToken({ commit }) {
    commit('updateAlcToken','alc_page_shown')
  },
  updateUID({ commit },uid) {
    commit('updateUID',uid)
  },
  /* ユーザーIDをlocalstrageへ保存 */
  setRememberUserId({ commit }, userid) {
    commit('updateUserId', userid)
  },
  /* パスワードをlocalstrageへ保存 */
  setRememberPassword({ commit }, password) {
    commit('updatePassword', password)
  },
  /* セッショントークンをlocalstrageへ保存 */
  setToken({ commit }, token) {
    commit('updateToken', token)
  },
  setDeviceInfo({ commit }, deviceId, platform, deviceVersion) {
    commit('setDeviceInfo', deviceId, platform, deviceVersion)
  },

  saveCartData({ commit }, cart) {
    commit('updateCart', cart)
  },
  clearSavedCartData({ commit }) {
    commit('updateCart', '')
  },
  SetShowScrollInfo({ commit }, val) {
    commit('setShowScrollInfo', val)
  },
}

// mutations
const mutations = {
  setLanguageLabels(state, lang) {
    state.lang = lang
  },
  setSessionKey(state, key) {
    state.session_key = key
  },
  setDeviceInfo(state, deviceId, platform, deviceVersion) {
    state.deviceId = deviceId
    state.platform = platform
    state.deviceVersion = deviceVersion
  },
  updateUID(state, uid) {
    if (uid === '') {
      localStorage.removeItem(LOCAL_STORAGE_KEY_UID)
    } else {
      localStorage.setItem(LOCAL_STORAGE_KEY_UID, uid)
    }
  },
  updatePassword(state, password) {
    if (password === '') {
      localStorage.removeItem(LOCAL_STORAGE_KEY_PASSWORD)
    } else {
      localStorage.setItem(LOCAL_STORAGE_KEY_PASSWORD, password)
    }
  },
  updateToken(state, token) {
    state.token = token
    if (token === '') {
      localStorage.removeItem(LOCAL_STORAGE_KEY_TOKEN)
    } else {
      localStorage.setItem(LOCAL_STORAGE_KEY_TOKEN, token)
    }
  },
  updateLineToken(state, token) {
    state.line_token = token
    if (token === '') {
      localStorage.removeItem(LOCAL_STORAGE_KEY_LINE_TOKEN+"_"+state.session_key)
    } else {
      localStorage.setItem(LOCAL_STORAGE_KEY_LINE_TOKEN+"_"+state.session_key, token)
    }
  },
  updateRepeaterToken(state, token) {
    state.repeater_token = token
    if (token === '') {
      localStorage.removeItem(LOCAL_STORAGE_KEY_REPEATER_TOKEN+"_"+state.session_key)
    } else {
      localStorage.setItem(LOCAL_STORAGE_KEY_REPEATER_TOKEN+"_"+state.session_key, token)
    }
  },
  updateAlcToken(state, token) {
    state.alc_token = token
    if (token === '') {
      localStorage.removeItem(LOCAL_STORAGE_KEY_ALC_TOKEN+"_"+state.session_key)
    } else {
      localStorage.setItem(LOCAL_STORAGE_KEY_ALC_TOKEN+"_"+state.session_key, token)
    }
  },

  updateCart(state, cart_data) {
    if (cart_data === '') {
      localStorage.removeItem(LOCAL_STORAGE_KEY_CART_DATA+"_"+state.session_key)
    } else {
      localStorage.setItem(LOCAL_STORAGE_KEY_CART_DATA+"_"+state.session_key, JSON.stringify(cart_data))
    }
  },
  setSessionToken(state){
    //ユニークIDを保存する
    localStorage.setItem(state.session_key, 'token_'+state.uid)
  },
  
  setShowScrollInfo(state, value){
    state.show_scroll_info = value
    localStorage.setItem(LOCAL_STORAGE_KEY_SHOW_INFO+"_"+state.session_key, value)
  },
  getSettings(state) {
    // state.labels = settings.language.find(item => item.lang === lang).labels
    state.lang = localStorage.getItem(LOCAL_STORAGE_KEY_LANGUAGE)
      ? localStorage.getItem(LOCAL_STORAGE_KEY_LANGUAGE)
      : '1'
    state.rememberUserId = localStorage.getItem(LOCAL_STORAGE_KEY_USERID)
      ? localStorage.getItem(LOCAL_STORAGE_KEY_USERID)
      : ''
    state.rememberPassowrd = localStorage.getItem(LOCAL_STORAGE_KEY_PASSWORD)
      ? localStorage.getItem(LOCAL_STORAGE_KEY_PASSWORD)
      : ''
    state.strage_saved_cart = localStorage.getItem(LOCAL_STORAGE_KEY_CART_DATA+"_"+state.session_key)
      ? localStorage.getItem(LOCAL_STORAGE_KEY_CART_DATA+"_"+state.session_key)
      : ''
    state.show_scroll_info = localStorage.getItem(LOCAL_STORAGE_KEY_SHOW_INFO+"_"+state.session_key)
      ? localStorage.getItem(LOCAL_STORAGE_KEY_SHOW_INFO+"_"+state.session_key)
      : 0
    
    state.token = localStorage.getItem(state.session_key)
      ? localStorage.getItem(state.session_key)
      : ''
    state.line_token = localStorage.getItem(LOCAL_STORAGE_KEY_LINE_TOKEN+"_"+state.session_key)
      ? localStorage.getItem(LOCAL_STORAGE_KEY_LINE_TOKEN+"_"+state.session_key)
      : ''
    state.repeater_token = localStorage.getItem(LOCAL_STORAGE_KEY_REPEATER_TOKEN+"_"+state.session_key)
      ? localStorage.getItem(LOCAL_STORAGE_KEY_REPEATER_TOKEN+"_"+state.session_key)
      : ''
    state.alc_token = localStorage.getItem(LOCAL_STORAGE_KEY_ALC_TOKEN+"_"+state.session_key)
      ? localStorage.getItem(LOCAL_STORAGE_KEY_ALC_TOKEN+"_"+state.session_key)
      : ''
    //UID　を取得。なければ新規に生成
    state.uid = localStorage.getItem(LOCAL_STORAGE_KEY_UID)
      ? localStorage.getItem(LOCAL_STORAGE_KEY_UID)
      : ''
    /*
    if(state.uid==''){
      state.uid=moment().format('YYYYMMDDHHmmss')
      localStorage.setItem(LOCAL_STORAGE_KEY_UID,  state.uid)
    }*/
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/local.js